export default __webpack_public_path__ + "static/media/detalii_apartament_120-min.2ef75ba1.jpg";